function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.273 12.14l-2.544-1.087a5.092 5.092 0 00-5.331-3.444l-.017.002a5.23 5.23 0 00-4.548 5.272v.576a5.244 5.244 0 01-4.098-1.724 1 1 0 00-1.733.775c.331 3.257 1.707 5.574 4.094 6.898a7.223 7.223 0 01-.573.6l-2.433 2.26A1 1 0 001.77 24h6.008A8.23 8.23 0 0016 15.78v-.49l2.375-1.361a1 1 0 00-.102-1.789zM15 15.78A7.23 7.23 0 017.779 23H1.77l2.434-2.26a8.171 8.171 0 001.065-1.212.5.5 0 00-.196-.745c-2.388-1.103-3.76-3.248-4.08-6.376a6.204 6.204 0 005.403 2.006.5.5 0 00.436-.496v-1.043a4.232 4.232 0 013.67-4.27 4.1 4.1 0 014.478 3.686q.018.188.019.377zm1-1.643v-1.472c0-.14-.012-.28-.024-.418l1.903.814z"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.75,
  cy: 11.75,
  r: 0.75
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 9C20 9 19 8.1 19 7.6s1-1.4 1.5-1.4 1.5.9 1.5 1.4A2.331 2.331 0 0120.5 9zM19 0h3l-.2 5h-2.7z"
});

function SvgCanaryMarginal(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "canaryMarginal.c692c.svg";
export { SvgCanaryMarginal as ReactComponent };